<ul role="tablist">
    <li role="tab" [routerLinkActive]="'tab__linkItem--active'" class="tab__linkItem"
        *ngFor="let tab of tabs">
        <a class="nav-link"
        href="#"
           [routerLink]="tab?.route"
           routerLinkActive #rla="routerLinkActive"
           (click)="selectedTab(tab)">
            {{ tab?.label | uppercase }}
        </a>
    </li>
</ul>

